import { DiceError, DiceExpression, type RollResult } from './dice.ts';
import type { Random } from './random.ts';

/**
 * The `[[...]]` inline rolls in a piece of text - "[[1d4+1]] Drax War Hounds" becomes
 * "3 Drax War Hounds" - as the desktop's `dice.InlineRolls`, the syntax virtual tabletops
 * use. Random-table results use it. Anything in the brackets that isn't a valid roll is
 * left as written, so a stray `[[note]]` never breaks a result.
 */

const INLINE = /\[\[([^[\]]+)\]\]/g;

export interface ExpandedText {
  readonly text: string;
  readonly rolls: readonly RollResult[];
}

export function hasInlineRolls(text: string): boolean {
  return /\[\[([^[\]]+)\]\]/.test(text);
}

export function expandInlineRolls(text: string, random: Random): ExpandedText {
  const rolls: RollResult[] = [];
  const expanded = text.replace(INLINE, (whole, expression: string) => {
    try {
      const roll = DiceExpression.parse(expression).roll(random);
      rolls.push(roll);
      return String(roll.total);
    } catch (e) {
      if (e instanceof DiceError) return whole;
      throw e;
    }
  });
  return { text: expanded, rolls };
}
